<template>
 <div class="scoreboard">
    <h1 v-if="currentYear">{{ currentYear.year.Title }} Scoreboard </h1>
    <score-card :currentYear="currentYear"></score-card>
    <h3>Nominations</h3>
    <ul class="list-group ballot-list">
      <li v-for="category in currentYearCategories" :key="category['.key']" class="list-group-item">
        <div v-if="isAuthenticated">
          <h3 class="d-inline-block">{{ category.name }}</h3>
          <ul class="nominee-list" v-if="category.nominees">
            <li class="score-item" v-for="(nominee, key, index) in category.nominees" :key="index" :class="{ winningNominee: nominee.winner }">
              <div><img class="winner" v-if="nominee.winner" src="../images/oscar-statue.png"></div><div>{{ nominee.nomineeName }} - <b>{{ nominee.nomineeMovie }}</b></div>
              <div class="voting-names"><span class="voter" v-for="voter in getVotes(category, nominee, key)" :key="voter">{{ voter }}</span></div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import sharedMixin from '../mixins/shared';
import scoreCard from './Scorecard';

export default {
  name: 'Scoreboard',
  mixins: [sharedMixin],
  components: {
    scoreCard
  },
  methods: {
    getVotes(category, nominee, key) {
      let categorykey = category['.key'];
      let voters = [];

      for (let voter in this.currentYear.year.votes) {
        if (this.currentYear.year.votes[voter][categorykey] === key) {
          voters.push(this.currentYear.year.votes[voter].displayName);
        }
      }

      return voters;
    }
  }
};
</script>

<style lang="scss">
  @import '../sass/_config';

  .scoreboard {
    margin-bottom: 50px;

    h1 {
      margin-bottom: 25px;
    }
  }

  .nominee-list {
    margin: 0;
    padding: 0;
  }
  .score-item {
    border-bottom: 1px solid $border;
    display: block;
    list-style-type: none;
    margin: 0;
    padding: 15px 10px 15px 0;

    @include breakpoint(md) {
      display: grid;
      grid-template-columns: 50px 33% auto;
    }

    .winner {
      display: block;
      margin: 0 auto;
      max-width: 60%;
    }

    div {
      align-self: center;
    }

    div:nth-child(2) {
      padding-right: 10px;
    }

    .voter{
      background: $border;
      border: 1px solid #bbbbbb;
      border-radius: 4px;
      color: $gold;
      font-size: 14px;
      line-height: 14px;
      margin-right: 5px;
      padding:5px 8px;
    }

    .voter:last-child {
      margin-right: 0;
    }

    &.winningNominee {
      background: rgba(199, 159, 39, .65);
      text-align: center;

      @include breakpoint(md) {
        text-align: left;
      }
    }
  }
  .score-item:last-child {
    border-bottom: 0;
  }
  .voting-names {
    margin-top: 15px;
    @include breakpoint(md) {
      margin-top: 0;
    }
  }
</style>
